export const properties = {
    host: "https://api.rexiusalgorithms.com"
};